import { defineStore } from 'pinia';
import { ref } from 'vue';
import { appointmentService, type AppointmentSlot, type CreateAppointmentData } from '../services/appointmentService';

export const useAppointmentStore = defineStore('appointment', () => {
  const isModalOpen = ref(false);
  const isLoading = ref(false);
  const isSubmitting = ref(false);
  const error = ref('');
  const slots = ref<AppointmentSlot[]>([]);
  const selectedSlot = ref<string | null>(null);
  const bookingSuccess = ref(false);

  function openModal() {
    isModalOpen.value = true;
    bookingSuccess.value = false;
    selectedSlot.value = null;
    error.value = '';
  }

  function closeModal() {
    isModalOpen.value = false;
    bookingSuccess.value = false;
    selectedSlot.value = null;
    error.value = '';
    slots.value = [];
  }

  function selectSlot(datetime: string) {
    selectedSlot.value = datetime;
  }

  async function fetchSlots(start: string, end: string) {
    isLoading.value = true;
    error.value = '';
    try {
      slots.value = await appointmentService.getAvailableSlots(start, end);
    } catch (err: any) {
      error.value = err.message || 'Impossible de charger les créneaux disponibles';
    } finally {
      isLoading.value = false;
    }
  }

  async function submitBooking(data: CreateAppointmentData) {
    isSubmitting.value = true;
    error.value = '';
    try {
      await appointmentService.createAppointment(data);
      bookingSuccess.value = true;
      selectedSlot.value = null;
    } catch (err: any) {
      error.value = err.message || 'Impossible de créer le rendez-vous';
      throw err;
    } finally {
      isSubmitting.value = false;
    }
  }

  return {
    isModalOpen,
    isLoading,
    isSubmitting,
    error,
    slots,
    selectedSlot,
    bookingSuccess,
    openModal,
    closeModal,
    selectSlot,
    fetchSlots,
    submitBooking
  };
});
